import React from "react";


/*********** COMPOSANTS ***********/
import ContextMenu from "containers/contextMenu/ContextMenu";
import { useContextMenu } from "./useContextMenu";
import { ProcessusProvider } from "composants/processus/ProcessusProvider";
import { useNavigate } from "react-router-dom";

const OctalContextMenu = () => {
  const { state, hideContextMenu } = useContextMenu();
  const navigate = useNavigate();

  const onHideContextMenu = () => {
    hideContextMenu();
  };


  const openMiniExpert = () => {
    if (state.contextTableName && state.contextIds) {
      const params = new URLSearchParams();
      params.append("miniExpertTableName", state.contextTableName);
      params.append("miniExpertSjmoCode", state.sjmoCode ? state.sjmoCode : "");
      params.append("miniExpertEntityId", state.contextIds[0]);
      navigate({ search: params.toString() });
    }
  };

  const showInformations = () => {
    const params = new URLSearchParams(window.location.search);
    params.append("contextColumnName", state.columnName || "");
    params.append("origineTableName", state.origineTableName || "");
    params.append("origineTableId", state.origineTableId || "");

    params.append("origineId", state.contextIds?.[0] ?? "");
    params.append("contextInfo", "true");
    navigate({ search: params.toString() });
  };

  if (state.show) {
    return (
      <ProcessusProvider
        sjmoCode={state.sjmoCode ?? "defaultSjmoCode"}
        tableName={state.contextTableName ?? "default"}
        selected={state.contextIds ?? undefined}
        entityFromView={state.entityFromView}
      >
        <ContextMenu
          onShowInformation={showInformations}
          onMiniExpertOpen={openMiniExpert}
          xpos={state.xpos}
          ypos={state.ypos}
          definition={state.definition}
          origineTableName={state.origineTableName} // table d'origine pour calcul de l'info
          columnName={state.columnName}
          hideContextMenu={onHideContextMenu}
          genericEntity={state.genericEntity}
          forceNewTab={state.forceNewTab}
        />
      </ProcessusProvider>
    );
  } else {
    return null;
  }
};

export default OctalContextMenu;
